<div class="inspections">
  <p class="main-case"></p>

  <table class="data-table floor-table" *ngFor="let table of tables">
    <thead>
      <tr>
        <th colspan="9" style="text-align: right">
          <span *ngIf="!table.withSprinklers">{{ table.name }}</span>
          <span *ngIf="table.withSprinklers"
            >{{ table.name }} (עם מתזים בשיא גובה חדר מדרגות)</span
          >
        </th>
      </tr>
      <tr>
        <th rowspan="2" style="width: 80px">
          <span>דלת פתוחה / סגורה</span>
        </th>
        <th rowspan="2">
          <span>{{ isCorridor() ? 'דלת' : 'קומה' }}</span>
        </th>
        <th colspan="2">
          <span>כח פתיחת דלת (Kg)</span>
        </th>
        <th colspan="2">
          <span>מהירות זרימת אוויר (m/s)</span>
        </th>
        <th colspan="2">
          <span>הפרש לחצים (mbar)</span>
        </th>
        <th rowspan="2" style="width: 70px">
          <span>מסקנה</span>
        </th>
      </tr>
      <tr>
        <th style="width: 70px">
          <span>נמדד</span>
        </th>
        <th style="width: 70px">
          <span>מקס'</span>
        </th>
        <th style="width: 70px">
          <span>מינ' נדרש</span>
        </th>
        <th style="width: 70px">
          <span>נמדד</span>
        </th>
        <th style="width: 70px">
          <span>מינימום נדרש</span>
        </th>
        <th style="width: 70px">
          <span>הפרש לחצים</span>
        </th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let item of table.floorsOrDoors">
        <td>
          <span>{{ item.doorState }}</span>
        </td>
        <td style="text-align: right">
          <span>{{ item.floorNumber }}</span>
        </td>
        <td>
          <span>{{ item.doorOpeningPower?.messured }}</span>
        </td>
        <td>
          <span>{{ item.doorOpeningPower?.max }}</span>
        </td>
        <td>
          <span>{{ item.airFlowSpeed?.min }}</span>
        </td>
        <td>
          <span>{{ item.airFlowSpeed?.messured }}</span>
        </td>
        <td>
          <span>{{ item.differentialPressure?.min }}</span>
        </td>
        <td>
          <span>{{ item.differentialPressure?.messured }}</span>
        </td>

        <td>
          <span *ngIf="item.isPassed">מתאים</span>
          <span *ngIf="!item.isPassed">לא מתאים</span>
        </td>
      </tr>
    </tbody>
  </table>

  <table class="data-table cases-table">
    <thead>
      <tr>
        <td
          colspan="4"
          style="
            border-bottom: none;
            text-align: center;
            font-weight: bold;
            font-size: 20px;
            font-style: italic;
            padding-top: 10px;
          "
        >
          תקן 1001 - חלק 2.2 - בטיחות אש בבניינים:
        </td>
      </tr>
      <tr>
        <td
          colspan="4"
          style="
            border-top: none;
            text-align: center;
            font-weight: bold;
            font-size: 18px;
            padding-bottom: 10px;
          "
        >
          מערכות בקרת עשן בבניינים (למעט בנייני מגורים שגובהם עד 13 מ'),
          קניונים, אטריומים וחללים גדולים דומים
        </td>
      </tr>
      <tr>
        <th style="width: 10%">
          <strong>הסעיף הנבדק</strong>
        </th>
        <th style="width: 43%">
          <strong>דרישת התקן</strong>
        </th>
        <th style="width: 10%">
          <strong>התאמה לתקן</strong>
        </th>
        <th style="width: 37%">
          <strong>הערות</strong>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of cases">
        <td class="section">
          <span [class.underline]="item.isTitle">{{ item.section }}</span>
        </td>
        <td>
          <span [class.underline]="item.isTitle">{{ item.title }}</span>
        </td>
        <td>
          <span>{{ getConclusion(item) }}</span>
        </td>
        <td>
          <span
            *ngFor="
              let note of item.notes | filterBy : ['addNotesToReport'] : true
            "
            >{{ note.notes }}</span
          >
        </td>
      </tr>
    </tbody>
  </table>

  <authority-labs-summary-notes
    [summaryNotes]="inspection?.summaryNotes"
    [root]="true"
  ></authority-labs-summary-notes>
</div>
